import React, {Component} from 'react'
import { withRouter } from 'react-router-dom'
import asyncWrapper from '../../../../../shared/javascripts/hocs/asyncWrapper'
import { Panel } from 'react-bootstrap'
import Loading from '../../../../../shared/javascripts/components/Loading'
import LoadingError from '../../../../../shared/javascripts/components/LoadingError'
import MonitoringApi from '../../api/MonitoringApi'
import ServerPanel from './ServerPanel'
import DataPanel from './DataPanel'

class TabContent extends Component {
  constructor(props) {
    super(props)
  }

  componentDidMount() {
    MonitoringApi.statuses('monitoring')
      .then(this.props.handleErrors)
      .then(response => {
        this.props.saveMonitoringData(response)
      }).then(() => this.props.setLoading()).catch(error => console.log(error))
  }

  render() {
    if(this.props.loading) { return <Loading />}
    const monitoringData = this.props.monitoringData;
    if(monitoringData.error || monitoringData.data.source_error) {return <LoadingError message={monitoringData.error || monitoringData.data.source_error} />}
    return(
      <div className='TabContent'>
        <ServerPanel data={monitoringData.data} />
        <DataPanel data={monitoringData.data} />
      </div>
    )
  }
}

export default asyncWrapper(withRouter(TabContent))


// WEBPACK FOOTER //
// ./src/admin/statuses/javascripts/components/Monitoring/TabContent.jsx